module.exports = __webpack_public_path__ + "img/188.problem_water_bar.b84ae3e9.svg";